import { wx_init, dd_init, not_wx_dd_init } from './monitor';
import { tools } from './tools';
import { h5api } from './service';

wx_init(function () {
    console.log('Auth Ready!');
    //需要授权之后执行的代码

    query();
}, function () {
    console.log('WxSDK Ready!');
    //需要微信JSSDK权限验证后执行的代码
    if (authAppid == 'wxe512506924dfd7b6') {
        wx.hideMenuItems({
            menuList: ['menuItem:copyUrl']
        });
    }

});

tools.tolink('.bg2_btn', '召唤好友');
tools.tolink('.bg1-2_btn', '召唤好友');
tools.tolink('.bg3_btn', '继续召唤好友助力');
$(function() {
    $(".index-btn").on('click', function() {
        tar.hitTag('立即参与');
        $(".index").hide();
        $(".container").show();

        var bottomGif = new Image();
        bottomGif.onload = function() {
            $(".bottom-gif").html(`
                <img src="${bottomGif.src}" />
                <img src="${require('../img/gif-tip.jpg').default}" style="margin-top: -1px;" />
            `);
        }
        bottomGif.src = require('../img/bottom-gif.gif').default;
    })
    $(".result-btn").bind('click', function() {
        tar.hitTag('点击领取');

        if(_echelon == 1 || _echelon == 2) {
            $(".result").hide();
            $(".address").show();
            $(".result .prize-img").removeClass('red-ant');
            $(".info-img").addClass('red-ant');
        } else if(_echelon == 3) {
            tar.hitTag('确认提交');
            submit();
        }
    });
    $('#agree').on('touchend', function() {
        // if (this.disabled) {
        //     weui.alert('请阅读活动规则声明后勾选');
        // }
    });
    $(".btn_rule").on('click', function() {
        $('.rule').css('display', 'flex');
        $(".rule-img").addClass('red-ant');
    });
    $(".submit").on('click', function() {
        tar.hitTag('确认提交');
        submit();
    });
    // $(".prize-img>img, .info-img>img").on('click', function() {
    //     $(this).parent().parent().hide();
    //     $(this).parent().removeClass('red-ant');
    // });
    $(".zjrs").on('click', function() {
        tar.hitTag('召集人手帮我抢');
        $(".share_tip").show();
    });
    $(".result-close").on('click', function() {
        $(this).parent().hide();
    });
    $(".rule-btn img").on('click', function() {
        console.log($(this).attr('name'))
        $(".rule").hide();
        $(".rule-img").removeClass('red-ant');
        $(this).attr('name') == 'yes' ? ($("#agree").prop('checked', true)) : '';
    });
    $(".h5_rule-btn").on('click', function() {
        $(".h5_rule").css('display', 'flex');
        $(".h5_rule-img").addClass('red-ant');
        $(".container").css({
            'height': '100vh',
            'overflow-y': 'hidden'
        });
    });
    $(".h5_rule .result-close").on('click', function() {
        $(".container").css({
            'height': 'auto',
            'overflow-y': 'auto'
        });
    });

})

let red_time_status = true, red_time = 1, playId;
const video = document.getElementById('video');
// 当前播放时长
function updateCurrentTime() {
    let currentTime = video.currentTime;

    $(".loading-line").css("width", currentTime * 5.34 + 'vw');
    if (currentTime * 5.34 > 4) {
        $(".gwc-icon").css("left", currentTime * 5.34 + 'vw');
    } else {
        $(".gwc-icon").css("left", '4vw');
    }
    if(Math.ceil(currentTime) == 15 && red_time_status) {
        console.log('抽红包');
        red_time_status = false;
        get_red();
    } else {
        console.log('播放' + currentTime + 's');
    }
}
video.addEventListener('play', function() {
    tar.hitTag('视频播放');
    playId = setInterval(updateCurrentTime, 500);
});
video.addEventListener('pause', function() {
    tar.hitTag('视频暂停');
    clearInterval(playId);
})
video.addEventListener('ended', function() {
    tar.hitTag('视频结束');
    clearInterval(playId);
})

// 看视频 抽红包
function get_red() {
    watchedDraw();
}

function watchedDraw() {
    h5api.watchedDraw({eventid: tarTid}).then(res => {
        tar.hitTag('看视频抽红包');
        if(res.errcode != 0) {
            return false;
        }
        if(res.data.coupon_value && res.data.coupon_value != 0) {
            $(".coupon_value").html(res.data.coupon_value / 100);
            $(".video_red").show();
            $(".red-img").addClass('red-ant');
        }
    })
}

let _echelon = 4;
function query() {
    weui.loading('加载中...');
    h5api.query({eventid: tarTid}).then(res => {
        weui.loading().hide();
        if(res.errcode != 0) {
            weui.alert(res.errmsg);
            return false;
        }
        let carve_up_fee = res.data.carve_up_fee;
        let obtain_info = res.data.obtain_info;
        let { score, echelon, rank } = res.data.user;
        _echelon = echelon;
        let rank_list = res.data.rank_list;
        let draw_after_watching = res.data.draw_after_watching;
        if(draw_after_watching) {
            // 已经抽过红包 状态改为false
            red_time_status = false;
        }
        $(".friend_num span").html(score || 0);
        $(".position span").html(rank || 999).parent().show();
        echelon && echelon < 4 && $(".bg3>img").attr('src', require(`../img/bg3-${echelon}.jpg`).default);
        if(echelon == 4) {
            $(".position").hide();
        } else {
            $(".position").show();
            if(res.data.obtain_flag) {
                $(".result-btn>img").attr('src', require(`../img/result-btn2.png`).default);
                $(".result-btn")
                .removeClass('ant')
                .unbind()
                .show();
            } else {
                $(".result-btn").show();
            }
        }

        // rank_list[i].child4_num >= 10000 ? (rank_list[i].child4_num / 10000).toFixed(1)+'w' : rank_list[i].child4_num
        for(let i=0;i<rank_list.length;i++) {
            if(i < 3) {
                $(`.top${i+1} .headimgurl`).html(`<img src="${rank_list[i].headimgurl}" />`);
                $(`.top${i+1} .nickname`).html(rank_list[i].nickname);
                $(`.top${i+1} .child4_num`).html(rank_list[i].child4_num >= 10000 ? (rank_list[i].child4_num / 10000).toFixed(2)+'w' : rank_list[i].child4_num);
                $(`.top${i+1}`).show();
            } else if(i >=3 && i < 9) {
                $('.top4').append(`
                    <div>
                        <div>${i+1}</div>
                        <div><img src="${rank_list[i].headimgurl}" /></div>
                        <div>${rank_list[i].nickname}</div>
                        <div>${rank_list[i].child4_num}</div>
                    </div>
                `);
            } else if(i >=9 && i < 75) {
                $('.echelon2').append(`
                    <div>
                        <div>${i+1}</div>
                        <div><img src="${rank_list[i].headimgurl}" /></div>
                        <div>${rank_list[i].nickname}</div>
                        <div>${rank_list[i].child4_num}</div>
                    </div>
                `);
            } else if(i >=76 && i < 88) {
                $('.echelon3').append(`
                    <div>
                        <div><img src="${rank_list[i].headimgurl}" /></div>
                    </div>
                `);
            }
        }

        if (res.data.over) {
            let image = new Image();
            image.onload = function() {
                echelon && echelon < 4 && $(".result .prize-img>img").attr('src', require(`../img/result${echelon}.png`).default);
                $(".result").css('display', 'flex');
                $(".prize-img").addClass('red-ant');

                if (echelon == 3) {
                    if (carve_up_fee && carve_up_fee > 0) {
                        $(".result-amount>span").html(carve_up_fee / 100)
                        $(".result-amount").show();
                    } else {
                        $(".result").hide();
                    }
                }
            }
            image.src = require(`../img/result${echelon}.png`).default;
        }
    })
}

function submit() {
    let data = {};
    if(_echelon == 1 || _echelon == 2) {
        let name = $("#name").val();
        if(!name) {
            weui.alert('请填写收货姓名');
            return;
        }
        let tel = $("#mobile").val();
        if(!tel) {
            weui.alert('请填写收货号码');
            return;
        } else {
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if(!reg.test(tel)) {
                weui.alert("请填写有效收货号码");
                return;
            }
        }
        let address = $("#address").val();
        if(!address) {
            weui.alert('请填写收货地址');
            return;
        }
        let agree = $("#agree").prop('checked');
        if(!agree) {
            weui.alert('请先阅读并同意活动规则声明');
            return;
        }

        data.name = name;
        data.tel = tel;
        data.address = address;
    }

    data.eventid = tarTid;
    data.echelon = _echelon;
    weui.loading('加载中...');
    h5api.submit(data).then(res => {
        weui.loading().hide();
        if(res.errcode != 0) {
            weui.alert(res.errmsg);
            return false;
        }

        weui.alert(res.errmsg);
        $(".result, .address").hide();
    })
}

function subscribe(type) {
    h5api.subscribe({
        eventid: tarTid,
        type
    })
}

// var subscribe_btn = document.getElementById('subscribe-btn-dhzfl');
// subscribe_btn.addEventListener('success', function (e) {
//     tar.hitTag('兑换真福利');
//     $(".result").css('display', 'flex');
//     $(".prize-img").addClass('red-ant');

//     subscribe('兑换真福利');
// });

var subscribe_btn1 = document.getElementById('subscribe-bg2_btn');
subscribe_btn1.addEventListener('success', function (e) {
    $(".bg2_btn").trigger('click');

    subscribe('召唤好友');
});

var subscribe_btn2 = document.getElementById('subscribe-bg1-2_btn');
subscribe_btn2.addEventListener('success', function (e) {
    $(".bg1-2_btn").trigger('click');

    subscribe('召唤好友');
});

var subscribe_btn3 = document.getElementById('subscribe-bg3_btn');
subscribe_btn3.addEventListener('success', function (e) {
    $(".bg3_btn").trigger('click');

    subscribe('召唤好友');
});
